import { useMemo } from "react";

import { ContactEntryType } from "../types/common";
import type { RevealedContactDto } from "../types/dto";

function useGetSortedPrivateData(privateData: RevealedContactDto): RevealedContactDto {
    return useMemo(() => {
        const { phoneNumbers } = privateData;

        if (!phoneNumbers) {
            return privateData;
        }

        return {
            ...privateData,

            // direct phone numbers should be first in a list
            phoneNumbers: privateData.phoneNumbers?.sort(({ internalType }) =>
                internalType === ContactEntryType.Mobile ? 1 : -1,
            ),
        };
    }, [privateData]);
}

export default useGetSortedPrivateData;
